import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import {BeatLoader} from "react-spinners";
import { override } from '../helpers/utils.js';

class AxisAggrStoreFilter extends Component{
    constructor(props) {
        super(props);
        this.state ={
            storeID:'',
            storeList:[],
            is_store_loading: true,
            storeValue: [],
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],

        }
        this.closeStoreList = this.closeStoreList.bind(this);
    }

    componentDidUpdate() {
        const { storeListOpen } = this.state;
        setTimeout(() => {
            if (storeListOpen) {
                window.addEventListener('click', this.closeStoreList);
            } else {
                window.removeEventListener('click', this.closeStoreList);
            }
        }, 0);
    }

    componentDidMount() {
        if(this.props.object_type==='Innoviti' && this.props.user_type ==='Internal') {
            this.getStore(this.props.object_code, 'innoviti', this.props.object_type, this.props.object_code, false,'');
        } else if(this.props.object_type==='Merchant'){
            this.getStore(this.props.object_code, 'merchant', this.props.object_type, this.props.object_code,false,'');
        } else if(this.props.object_type==='Chain'){
            this.getStore(this.props.object_code, 'chain', this.props.object_type, this.props.object_code,false,'');
        }
        else if(this.props.object_type==='Store'){
            var storeData = [];
            this.props.object_code.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData, true);
        }
    }
    restStoreFilter(){
        this.setState({
            storeID: [],
        })
    }
    getStore(code, type, object_type, object_code,is_search, search_value) {
        //alert(code); alert(type)
        if(is_search===false){
            this.setState({
                storeID:[]
            })
        }
        this.setState({
            search_code: code,
            search_type: type,
            object_type: object_type,
            search_object_code: object_code
        })
        let selected_val = [];
        if(is_search===true){
            selected_val = this.state.storeObject
        }
        this.setState({
            storeList:[],
            is_store_loading: true
        })
        axios.post(config.get('API_URL')+'/filters/get-axis-batch-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code,
                is_search: is_search,
                search_value: search_value,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            //this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            let res = []
            if (Array.isArray(this.state.storeID) && this.state.storeID) {
                const uniq = new Set(storeList.map(e => JSON.stringify(e)));

                storeList = Array.from(uniq).map(e => JSON.parse(e));

            }
            this.setState({
                storeList:storeList,
                is_store_loading: false
            })
        });
    }
    changeStore(login_type, store_object, checked_item, e) {
        if (login_type === 'store') {
            let value='';
            let sidArray = [];
            if(store_object.length<1){
                value = null;
                sidArray = '';
            }
            else{
                store_object.map((sids, i) => {
                    sidArray.push(sids.value)
                });
            }
            this.setState({
                storeID: sidArray,
                storeValue:store_object,
                ciutidIds: '',
                ciutidValue: [],
                isChange: true
            });
        } else {
            let item_list = this.state.storeID;
            let item_list_object = this.state.storeObject;
            let checked_list = store_object.value;
            let checked_list_object = store_object;
            //console.log(checked_list);
            if(checked_item===false) {
                const newData = [store_object, ...this.state.storeList.filter(item => item !== store_object)];
                this.setState({
                    storeID: [...this.state.storeID,  store_object.value],
                    storeObject: [...this.state.storeObject, store_object],
                    isChange: true,
                    storeList: newData,
                    ciutidIds: '',
                    ciutidValue: [],
                });

            } else{
                let index = item_list.indexOf(checked_list);
                if (index > -1) {
                    item_list.splice(index, 1);
                    if(item_list.length<1) {
                        item_list='';
                    }
                    this.setState({
                        storeID: item_list,

                    })
                }
                let index_object = item_list_object.indexOf(checked_list_object);
                if (index_object > -1) {
                    item_list_object.splice(index_object, 1);
                    if(item_list_object.length<1) {
                        item_list_object=[];
                    }
                    this.setState({
                        storeObject: item_list_object,
                        isChange: true
                    })
                }
            }
            setTimeout(function() {
                this.props.onSelectStore(this.state.storeID);
            }.bind(this), 200);
            if (e.target.type === 'checkbox') {
                e.stopPropagation();
            }
        }

    }
    storeToggleList() {
        this.setState({
            storeListOpen: !this.state.storeListOpen,
        });
    }
    storeFilterList(e){
        var value = e.target.value

        setTimeout(function() {
            this.getStore(this.state.search_code, this.state.search_type, this.state.object_type, this.state.search_object_code,true, value);
        }.bind(this), 200);
    }
    closeStoreList() {
        this.setState({
            storeListOpen: false,
        });
    }

    render() {
        const store_lists = this.state.storeList.map((store_object, index) => {
            // console.log("store_object");
            // console.log(store_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.storeID.includes(store_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.changeStore.bind(this, '', store_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{store_object.label}
                </li>
            )
        })

        return(

            <div className="dd-wrapper">
                <div className="dd-header" onClick={() => this.storeToggleList()}>
                    {this.state.storeID==''?
                        <div className="dd-header-title">{this.state.storeHeaderTitle}</div>:
                        <div className="dd-header-title">{this.state.storeID.length} Selected</div>
                    }

                    <i className="fa fa-angle-down"></i>
                </div>
                {this.state.storeListOpen ===true?
                    <div
                        role="list"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <input
                            className="dd-list-search-bar"
                            placeholder="Search"
                            onChange={(e) => this.storeFilterList(e)}
                        />
                        <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                        {/*<div className="dd-scroll-list">*/}
                        <ul className="dd-list">
                            {this.state.is_store_loading===true?
                                <li>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={5}
                                        color={'#666666'}
                                        loading={this.state.is_store_loading}
                                    />
                                </li>: null}
                            {store_lists}

                        </ul> </div>: null }
                {/*</div>*/}
            </div>

        );
    }
}

export default AxisAggrStoreFilter;